import { styled } from 'styled-components'

export const ArrivesBeforeHolidayBadge = styled.div`
  display: inline-block;
  background: #eaf2e7;
  padding: 3px 5px;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  line-height: 114%;
  color: #2a8112;
`
